export default __webpack_public_path__ + "static/media/play_branco.12614bb4.svg";